var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMediaFolder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "perm_media"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M2.40029 5.40001H0.800293V9.40001H0.808293L0.800293 16.6C0.800293 17.48 1.52029 18.2 2.40029 18.2H16.8003V16.6H2.40029V5.40001ZM6.40029 12.6H17.6003L14.8003 9.00001L12.8003 11.408L10.0003 7.80001L6.40029 12.6ZM18.4003 3.80001H12.0003L10.4003 2.20001H5.60029C4.72029 2.20001 4.00829 2.92001 4.00829 3.80001L4.00029 13.4C4.00029 14.28 4.72029 15 5.60029 15H18.4003C19.2803 15 20.0003 14.28 20.0003 13.4V5.40001C20.0003 4.52001 19.2803 3.80001 18.4003 3.80001ZM18.4003 13.4H5.60029V3.80001H9.73629L11.3363 5.40001H18.4003V13.4Z",
    fill: "#343333"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMediaFolder);
export default __webpack_public_path__ + "static/media/media-folder.38eb6905c0af8025874ad1f997a79d8f.svg";
export { ForwardRef as ReactComponent };